var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDialogIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6415 15.1494L1.72721 27.0639C1.36449 27.4266 0.776302 27.4266 0.413602 27.0639C0.0509347 26.7013 0.051001 26.1131 0.413668 25.7504L12.328 13.8359L0.413652 1.92152C0.0509167 1.55878 0.0509181 0.970707 0.413656 0.607969C0.776364 0.24526 1.36447 0.245261 1.72718 0.607969L13.6415 12.5224L25.5562 0.607973C25.9187 0.245407 26.5067 0.245146 26.8697 0.608154C27.2323 0.970868 27.2322 1.55892 26.8696 1.92159L14.955 13.8359L26.8696 25.7505C27.2323 26.1131 27.2323 26.7013 26.8696 27.0639C26.507 27.4266 25.9188 27.4266 25.5561 27.0639L13.6415 15.1494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDialogIcon);
export default __webpack_public_path__ + "static/media/close-dialog-icon.8bb5514ec949b16e3c572c66d831012f.svg";
export { ForwardRef as ReactComponent };